/** Where an inbound enquiry from an unauthenticated visitor goes. */
const SALES_EMAIL = 'business@helium.com';

const SUBJECT = 'Helium AI enquiry';

/**
 * A prefilled sales enquiry as a `mailto:` URL.
 *
 * There is no endpoint behind this: the visitor's own mail client sends the
 * message, so nothing here holds a credential, accepts a POST, or can be
 * submitted by a bot, and the sender reads every line before it goes.
 *
 * `context` names where the enquiry came from, which is the one thing the
 * recipient cannot recover from the message itself. It reaches the body as
 * plain text the sender can edit or delete.
 */
export function salesMailto(context: string): string {
  const body = [
    'Hi Helium team,',
    '',
    '(what you are looking to cover, and roughly how many venues)',
    '',
    '--',
    context,
  ].join('\n');
  return `mailto:${SALES_EMAIL}?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(body)}`;
}
